import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Logo from "../images/logo.png";
import { AiOutlineHome } from "react-icons/ai";
import { SlUserFollowing } from "react-icons/sl";
import { HiOutlineBriefcase } from "react-icons/hi";
import { PiGraduationCap } from "react-icons/pi";
import { LuLayers } from "react-icons/lu";
import { BiMessage } from "react-icons/bi";
import { GiSkills } from "react-icons/gi";

const Sidebar = ({ menuBar, setMenuBar }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleNavigation = (hash) => {
    if (location.pathname === "/") {
      // If already on home page, just scroll to the section
      const section = document.querySelector(hash);
      if (section) section.scrollIntoView({ behavior: "smooth" });
    } else {
      // Navigate to home page and then scroll to the section
      navigate(`/${hash}`);
    }
    setMenuBar(true); // Close sidebar after clicking
  };

  return (
    <aside className={menuBar ? "aside" : "aside show"}>
      <a href="#home" className="logo" onClick={() => setMenuBar(true)}>
        <img onClick={() => handleNavigation("#home")} src={Logo} alt="logo" />
      </a>

      <ul className="navlinks">
        <li className="navitem">
          <button
            className="navlink"
            onClick={() => handleNavigation("#home")}
          >
            <AiOutlineHome className="navIcon" />
            Home
          </button>
        </li>

        <li className="navitem">
          <button
            className="navlink"
            onClick={() => handleNavigation("#about")}
          >
            <SlUserFollowing className="navIcon" />
            About
          </button>
        </li>

        {/* <li className="navitem">
          <button
            className="navlink"
            onClick={() => handleNavigation("#services")}
          >
            <HiOutlineBriefcase className="navIcon" /> Services
          </button>
        </li> */}

        <li className="navitem">
          <button
            className="navlink"
            onClick={() => handleNavigation("#skills")}
          >
            <GiSkills className="navIcon" /> Skills
          </button>
        </li>

        <li className="navitem">
          <button
            className="navlink"
            onClick={() => handleNavigation("#education")}
          >
            <PiGraduationCap className="navIcon" /> Education
          </button>
        </li>

        <li className="navitem">
          <button
            className="navlink"
            onClick={() => handleNavigation("#portfolio")}
          >
            <LuLayers className="navIcon" /> Portfolio
          </button>
        </li>

        <li className="navitem">
          <button
            className="navlink"
            onClick={() => handleNavigation("#contact")}
          >
            <BiMessage className="navIcon" /> Contact
          </button>
        </li>
      </ul>

      <div className="side_footer">
        <span className="copyright">&copy; 2024 - 2025. </span>
      </div>
    </aside>
  );
};

export default Sidebar;
